<div class="header-main">
    <core-title-section [title]="'Project <small>(#' + project.id+ ')</small>'"></core-title-section>
    <div [hidden]="edit" class="labels-edit-container"><core-labels-text [labels]="project.labels"></core-labels-text></div>
    <core-helpers-navigation-three-dots-menu [menu]="menu" (action)="onMenuSelect($event)"></core-helpers-navigation-three-dots-menu>
    <project-details-info-edit-labels [hidden]="!edit" (close)="toggleEdit()"></project-details-info-edit-labels>
    <core-helpers-box-alert-message-icon
      [hidden]="!edit || !uploaded"
      [text]="'The tags of all uploaded Artworks will be modified.'"
      [icon]="'alert_notice'"
    ></core-helpers-box-alert-message-icon>
  </div>
